import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RecoverForm } from "../../../components/Admin/Auth";
import { useLanguage } from "../../../contexts";
import { EcosystemPanel } from "../Auth/EcosystemPanel";
import { BrujulaPanel } from "../Auth/BrujulaPanel";
import { EcosystemMobileHeader } from "../Auth/EcosystemMobileHeader";
import { LanguageSwitcher } from "../Auth/LanguageSwitcher";
import { SocialLinks } from "../Auth/SocialLinks";
import logoInk from "../../../assets/png/brand/logo-ink.png";
import "./Recover.scss";

export function Recover() {
  const navigate = useNavigate();
  // Mismo sorteo que Auth.js: una de las dos direcciones visuales del panel
  // derecho, una vez por montaje.
  const [useBrujula] = useState(() => Math.random() < 0.5);
  const { changeLanguage, translations, language } = useLanguage();
  const t = (key) => translations[key] || key;

  useEffect(() => {
    if (!localStorage.getItem("appLanguage")) {
      const idiomaNavegador = navigator.language || navigator.userLanguage;
      const idioma = idiomaNavegador.split("-")[0];
      changeLanguage(["es", "en", "pt", "fr"].includes(idioma) ? idioma : "es");
    }
  }, []);

  return (
    <div className="login-page">
      <EcosystemMobileHeader t={t} language={language} changeLanguage={changeLanguage} />

      <div className="login-page__grid">
        <div className="login-panel">
          <img src={logoInk} alt="sustemia" className="login-panel__logo" />

          <div className="login-panel__center">
            <span className="login-panel__kicker">{t("login_kicker")}</span>

            <RecoverForm />
            <div className="login-panel__register">
              <a
                href="#login"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/admin");
                }}
              >
                {t("back_to_login")}
              </a>
            </div>
          </div>

          <footer className="login-panel__footer">
            <div className="login-panel__footer-row">
              <span className="login-panel__footer-tagline">{t("login_footer_tagline")}</span>
              <LanguageSwitcher
                language={language}
                changeLanguage={changeLanguage}
                className="login-panel__footer-lang"
              />
            </div>
            <SocialLinks className="login-panel__footer-socials" />
          </footer>
        </div>

        {useBrujula ? (
          <BrujulaPanel t={t} language={language} />
        ) : (
          <EcosystemPanel t={t} language={language} />
        )}
      </div>
    </div>
  );
}
